import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "PostMailDeeplinkBoot" */ './lazyDeeplinkIndex'),
    true
);

export let lazySetupMailDeeplinkCommonPostRender = new LazyAction(
    lazyModule,
    m => m.setupMailDeeplinkCommonPostRender
);

export let lazySetupMailModuleCommonPostRender = new LazyAction(
    lazyModule,
    m => m.setupMailModuleCommonPostRender
);

export const lazyInitializeNotifications = new LazyImport(
    lazyModule,
    m => m.initializeNotifications
);
